<div style="display: flex;">
    <mat-icon [ngClass]="getStatusClass()">fiber_manual_record</mat-icon>
    <span class="status-label">{{getStatusText()}}</span>
    <span *ngIf="label" class="status-label" style="margin-left: 5px;">{{label}}</span>
</div>